import { TemplateBlock } from '../BaseBlock';
import { generateBlockID } from '../generateBlockID';

// Need to use interface here to allow typescript-json-schema to correctly generate enum constraints for the 'type' field
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface HeadingBlock extends TemplateBlock {
  type: 'Heading';
  label: string;
}

export function blockIsHeading(block: TemplateBlock): block is HeadingBlock {
  return block.type === 'Heading';
}

export function newHeadingBlock(
  label: string,
  extraProps?: Partial<HeadingBlock>
): HeadingBlock {
  return {
    type: 'Heading',
    id: generateBlockID(),
    label,
    ...extraProps,
  };
}

export function updateLabel(heading: HeadingBlock, label: string) {
  return { ...heading, label };
}
